// Module
var code = "<mn-number-container type=\"integer\" empty=\"true\" ng-model-options=\"{updateOn: 'blur'}\"></mn-number-container>";
// Exports
module.exports = code;